import React from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "../../../components/admin/sidebar/adminSidebar";
import "./dashBoard.css"; // 관리자 페이지 스타일 추가

export default function DashBoard() {
  const navigate = useNavigate();

  // 카드마다 고유한 색상 선택
  const cardData = [
    {
      title: "공지사항 관리",
      text: "새로운 공지사항을 등록하거나 기존 공지사항을 관리할 수 있습니다.",
      path: "/admin/notice/list",
      color: "#1A6DFF", // 메인 컬러
    },
    {
      title: "회원 관리",
      text: "등록/요청된 회원 정보를 확인하고 관리할 수 있습니다.",
      path: "/admin/user/register-request",
      color: "#FF5733", // 오렌지
    },
    {
      title: "결재 관리",
      text: "요청된 결재 정보를 확인하고 관리할 수 있습니다.",
      path: "/admin/approval-request/request",
      color: "#28A745", // 녹색
    },
    {
      title: "학술 세미나 관리",
      text: "학술 세미나 관련 게시물을 등록하거나 기존 게시물을 관리할 수 있습니다.",
      path: "/admin/notice/list",
      color: "#FFC107", // 노란색
    },
    {
      title: "연구 프로젝트 관리",
      text: "연구 프로젝트 관련 게시물을 등록하거나 기존 게시물을 관리할 수 있습니다.",
      path: "/admin/user/register-request",
      color: "#17A2B8", // 청록색
    },
    {
      title: "관광 전문가 양성 교육 관리",
      text: "관광 전문가 양성 교육 관련 게시물을 등록하거나 기존 게시물을 관리할 수 있습니다.",
      path: "/admin/approval-request/request",
      color: "#6610F2", // 보라색
    },
    {
      title: "장학 사업 관리",
      text: "장학 사업 관련 게시물을 등록하거나 기존 게시물을 관리할 수 있습니다.",
      path: "/admin/notice/list",
      color: "#E83E8C", // 핑크
    },
    {
      title: "관광 취업센터 관리",
      text: "관광 취업센터 관련 게시물을 등록하거나 기존 게시물을 관리할 수 있습니다.",
      path: "/admin/user/register-request",
      color: "#20C997", // 연한 녹색
    },
    {
      title: "기타사업 관리",
      text: "기타사업 관련 게시물을 등록하거나 기존 게시물을 관리할 수 있습니다.",
      path: "/admin/approval-request/request",
      color: "#343A40", // 어두운 회색
    },
    {
      title: "업계소식 관리",
      text: "업계소식 관련 게시물을 등록하거나 기존 게시물을 관리할 수 있습니다.",
      path: "/admin/notice/list",
      color: "#6C757D", // 회색
    },
  ];

  return (
    <AdminSidebar>
      <h2 className="text-center mb-4">관리자 대시보드</h2>
      <Row className="gy-4">
        {cardData.map((card, index) => (
          <Col md={4} className="d-flex" key={index}>
            <Card className="text-center admin-card flex-fill">
              <Card.Body className="d-flex flex-column">
                <Card.Title>{card.title}</Card.Title>
                <Card.Text>{card.text}</Card.Text>
                <Button
                  style={{
                    backgroundColor: card.color,
                    borderColor: card.color,
                  }}
                  onClick={() => navigate(card.path)}
                  className="mt-auto text-white"
                >
                  {card.title}
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </AdminSidebar>
  );
}
